export const COOKIE_CONSENT_KEY = "fg_cookie_consent";
export const COOKIE_CONSENT_VALUES = {
  ALL: "all",
  NECESSARY: "necessary",
  NONE: "none",
};
export const COOKIE_NO_CONTENT_ICON = "/assets/images/disabled_icon.svg";
export const COOKIE_ICON = "/assets/images/cookie_icon.svg";
